import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-889b959e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-primary-dark" }
const _hoisted_2 = {
  key: 4,
  class: "d-flex align-items-center ml-auto text-size-14 text-yellow"
}
const _hoisted_3 = {
  key: 5,
  class: "d-flex align-items-center ml-auto text-size-14 text-red"
}
const _hoisted_4 = {
  key: 6,
  class: "d-flex align-items-center ml-auto text-size-14 text-yellow"
}
const _hoisted_5 = {
  key: 7,
  class: "d-flex align-items-center ml-auto text-size-14 text-green"
}
const _hoisted_6 = {
  key: 8,
  class: "d-flex align-items-center ml-auto text-size-14 text-red"
}
const _hoisted_7 = {
  key: 9,
  class: "d-flex align-items-center ml-auto text-size-14 text-green"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: _ctx.to,
    class: "item"
  }, {
    default: _withCtx(() => [
      (!_ctx.hasRegistered)
        ? (_openBlock(), _createBlock(_component_FeatherIcon, {
            key: 0,
            icon: "alert-circle",
            size: "16",
            class: "mr-2 text-red"
          }))
        : (_ctx.isUnderExamination || _ctx.isModified)
          ? (_openBlock(), _createBlock(_component_FeatherIcon, {
              key: 1,
              icon: "circle",
              size: "16",
              class: "mr-2 text-yellow"
            }))
          : (_ctx.isRejected && !_ctx.isVerified)
            ? (_openBlock(), _createBlock(_component_FeatherIcon, {
                key: 2,
                icon: "alert-circle",
                size: "16",
                class: "mr-2 text-red"
              }))
            : (_openBlock(), _createBlock(_component_FeatherIcon, {
                key: 3,
                icon: "check-circle",
                size: "16",
                class: "mr-2 text-green"
              })),
      _createTextVNode(),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1),
      _createTextVNode(),
      (_ctx.isModified)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(_component_FeatherIcon, {
              icon: "alert-circle",
              size: "14",
              class: "mr-1"
            }),
            _createTextVNode("\n      入力済み\n    ")
          ]))
        : (!_ctx.hasRegistered)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createVNode(_component_FeatherIcon, {
                icon: "alert-circle",
                size: "14",
                class: "mr-1"
              }),
              _createTextVNode("\n      未入力\n    ")
            ]))
          : (_ctx.isUnderExamination)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createVNode(_component_FeatherIcon, {
                  icon: "circle",
                  size: "14",
                  class: "mr-1"
                }),
                _createTextVNode("\n      審査中\n    ")
              ]))
            : (_ctx.isVerified)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createVNode(_component_FeatherIcon, {
                    icon: "check-circle",
                    size: "14",
                    class: "mr-1"
                  }),
                  _createTextVNode("\n      認証済み\n    ")
                ]))
              : (_ctx.isRejected && !_ctx.isModified)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_FeatherIcon, {
                      icon: "alert-circle",
                      size: "14",
                      class: "mr-1"
                    }),
                    _createTextVNode("\n      差戻し\n    ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createVNode(_component_FeatherIcon, {
                      icon: "check-circle",
                      size: "14",
                      class: "mr-1"
                    }),
                    _createTextVNode("\n      入力済み\n    ")
                  ]))
    ], undefined, true),
    _: 1
  }, 8, ["to"]))
}